import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../helpers/settings';
import { Result } from '../models/general';
import { BookingModel } from '../models/booking-model';
import { BookingConfig } from '../models/booking-model';
import { RefreshVerificationService } from './refresh-verification.service';
import { InvoiceModel } from '../models/invoice-model';
import { ChartModelConfig } from '../models/ChartModelConfig';
export interface PaginationData {
	docs: BookingModel[];
	total: number;
	limit: number;
	page: number;
	pages: number;
}

@Injectable({
	providedIn: 'root'
})
export class BookingModelService {
	readonly BASE_URL = `${GlobalVariable.server.host}/booking-model`;

	constructor(private httpClient: HttpClient, private refreshVerifService: RefreshVerificationService) {}

	find(
		fromAppComponent: boolean,
		route: string,
		projectId: string,
		attributes: string = null
	): Observable<BookingModel[]> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		// params = params.set('attributes', attributes ?? null);
		if (projectId) {
			params = params.set('project', projectId);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<BookingModel[]>(`${this.BASE_URL}/find`, { params })
		);
	}
	findByProject(projectId: string, fromAppComponent: boolean, route: string): Observable<BookingModel[]> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<BookingModel[]>(`${this.BASE_URL}/find-by-project/${projectId}`, { params })
		);
	}

	findById(id: string, fromAppComponent: boolean, route: string, projectId: string): Observable<BookingModel> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<BookingModel>(`${this.BASE_URL}/find-by-id/${id}`, { params })
		);
	}

	create(bookingModel: Partial<BookingModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<Result>(`${this.BASE_URL}/create`, bookingModel)
		);
	}

	edit(bookingModel: Partial<BookingModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(this.httpClient.put<Result>(`${this.BASE_URL}/edit`, bookingModel));
	}

	delete(bookingModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/delete/${bookingModelId}`)
		);
	}

	duplicate(model: Partial<BookingModel>): Observable<{ _id?: string }> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<{ _id: string }>(`${this.BASE_URL}/duplicate`, model)
		);
	}

	updateBookingConfig(data: { bookingModel: string; bookingConfig: BookingConfig }): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.put<Result>(`${this.BASE_URL}/booking-config/${data.bookingModel}`, data)
		);
	}
	archive(bookingModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/archive/${bookingModelId}`)
		);
	}
	isUsed(bookingModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.get<Result>(`${this.BASE_URL}/if-is-Used/${bookingModelId}`)
		);
	}
}
